import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import InputMask from 'react-input-mask';
import styles from './Popup.module.sass';
import leadFormStyles from '../LeadForm/LeadForm.module.sass';
import { popupContent } from './Popup.content';
import { Button } from '../ui/Button';
import image from './assets/image.webp';
import { IconClose } from './assets/iconClose';
import { submitCallback } from '../../api/submitCallback';
import { buildLayoutComment } from '../../utils/buildLayoutComment';
import { isPhoneComplete } from '../../utils/isPhoneComplete';

export function Popup({ onClose, selectedLayout }) {
  const innerRef = useRef(null);
  const [phone, setPhone] = useState('');
  const [consent, setConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { title, text, buttonLabel, consentLabel, disclaimer } = popupContent;

  const comment = useMemo(() => buildLayoutComment(selectedLayout), [selectedLayout]);

  useEffect(() => {
    if (selectedLayout) {
      console.log('Selected layout:', selectedLayout);
    }
  }, [selectedLayout]);

  const handleBackgroundClick = (e) => {
    if (innerRef.current && !innerRef.current.contains(e.target)) {
      onClose?.();
    }
  };

  const handleSubmit = useCallback(async () => {
    if (!consent) return;
    if (!isPhoneComplete(phone)) return;

    const formData = {
      name: '',
      phone,
      comment,
      request_type: 'callback',
    };

    console.log('Callback form submit:', formData);

    setIsSubmitting(true);

    try {
      await submitCallback(formData);
      onClose?.();
    } catch (error) {
      console.error('Callback form submit failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  }, [comment, consent, onClose, phone]);

  return (
    <div className={styles.popup} onClick={handleBackgroundClick}>
      <div ref={innerRef} className={styles.popup__inner}>
        <div className={styles.popup__close} onClick={onClose}>
          <IconClose className={styles['popup__close']} />
        </div>

        <img src={image} alt="" className={styles['popup__image']} />

        <div className={styles.popup__content}>
          <div
            className={styles.popup__title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div
            className={styles.popup__text}
            dangerouslySetInnerHTML={{ __html: text }}
          />

          <form id="callback" noValidate className={styles.popup__form}>
            {selectedLayout ? (
              <>
                <input type="hidden" name="rooms" value={selectedLayout.rooms} />
                <input type="hidden" name="title" value={selectedLayout.title} />
                <input type="hidden" name="area" value={selectedLayout.area} />
              </>
            ) : null}
            <input type="hidden" name="comment" value={comment} />
            <input type="hidden" name="request_type" value="callback" />

            <div className={styles.popup__field}>
              <label className={styles.popup__label}>Введите номер телефона</label>
              <InputMask
                maskChar=" "
                className={styles.popup__input}
                mask="+7 999 999 99 99"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                type="tel"
              />
            </div>
          </form>

          <Button
            variant="simple"
            className={styles['popup__button']}
            label={buttonLabel}
            onClick={handleSubmit}
            disabled={isSubmitting || !consent || !isPhoneComplete(phone)}
          />

          <div
            className={`${leadFormStyles.leadForm__legal} ${leadFormStyles.leadForm__legal_viewing}`}
          >
            <label className={leadFormStyles.leadForm__consent}>
              <span
                className={`${leadFormStyles.leadForm__checkbox} ${consent ? leadFormStyles['leadForm__checkbox--checked'] : ''}`}
                aria-hidden
              />
              <input
                type="checkbox"
                className={leadFormStyles.leadForm__checkboxInput}
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
              />
              <span className={leadFormStyles.leadForm__consentText}>{consentLabel}</span>
            </label>

            <p
              className={leadFormStyles.leadForm__disclaimer}
              dangerouslySetInnerHTML={{ __html: disclaimer }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
